import Container from './Container.template'

export default Container
